export enum AdvertisingBannerPosition {
  Top = 1,
  Bottom = 2
}

export enum AdvertisingBannerImageTarget {
  Desktop = 1,
  Mobile = 2
}

export interface AdvertisingConfigurationDto {
  id: number;
  position: AdvertisingBannerPosition;
  images: AdvertisingConfigurationImageDto[];
  selectedPageGroups: AdvertisingSelectedPageGroupDto[];
  filterQuery: string;
  startsAt: Date | null;
  endsAt: Date | null;
  active: boolean;
}

export interface AdvertisingSelectedPageGroupDto {
  id: number;
  advertisingConfigurationId: number;
  pageGroupId: number;
  pageIdentifier: string;
}

export interface AdvertisingConfigurationImageDto {
  id: number;
  advertisingConfigurationId: number;
  target: AdvertisingBannerImageTarget;
  imageUrl: string;
  linkUrl: string;
}

export interface AdvertisingConfigurationImageUploadDto {
  target: AdvertisingBannerImageTarget;
  fileBlob: File;
  linkUrl: string;
}

export interface CreateAdvertisingConfigurationDto {
  position: AdvertisingBannerPosition;
  filterQuery: string;
  newImages: AdvertisingConfigurationImageUploadDto[];
  selectedPageIdentifiers: string[];
  startsAt: Date | null;
  endsAt: Date | null;
}

export interface UpdateAdvertisingConfigurationDto {
  id: number;
  filterQuery: string;
  newImages: AdvertisingConfigurationImageUploadDto[];
  selectedPageIdentifiers: string[];
  startsAt: Date | null;
  endsAt: Date | null;
}

export interface AdvertisingBannerDto {
  pageIdentifiers: string[];
  position: AdvertisingBannerPosition;
  target: AdvertisingBannerImageTarget;
  imageUrl: string;
  linkUrl: string;
}
